<template>
  <MenuComponent modulo="embargos" :menuInferior="menuInferior"/>
  <main class="items-center w-full px-4 py-4 mx-auto my-10 bg-white rounded-lg shadow-md sm:w-11/12">
    <router-view v-slot="{ Component }">
      <Suspense timeout="0">
        <template #default>
          <div class="container mx-auto">
            <component :is="Component"></component>
          </div>
        </template>
        <template #fallback>
          <div class="container mx-auto">
            <LoadingComponent></LoadingComponent>
          </div>
        </template>
      </Suspense>
    </router-view>
  </main>
</template>
<script>
import MenuComponent from "@/layouts/MenuComponent";
import LoadingComponent from "@/layouts/LoadingComponent";
import {ref} from 'vue';

export default {
  name: "MenuEmbargos",
  components: { MenuComponent, LoadingComponent },

  /**
   * Configuración del componente con Vue 3 Composition API.
   * @function
   * @returns {object} - Objeto con las propiedades del componente.
   */
  setup() {
    /**
     * Función para cargar las opciones del menú inferior.
     * @function
     * @returns {array} - Arreglo con las opciones del menú inferior.
     */
    const cargarMenuInferior = () => {
      const userStored = JSON.parse(localStorage.getItem("user"));
      const elementos = [];

      let idPadre = '';

      let newPermisos = userStored.permisosUsuariosEntities.concat(userStored.rol.permisosRolesEntities);

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso.menu
        if(dataMenu.name == 'MenuEmbargos'){
          idPadre = dataMenu.id
        }
      }

      for(let permiso in newPermisos)
      {
        let dataMenu = newPermisos[permiso].permiso
    
        if(dataMenu.estado)
        {
          if(dataMenu.menu.menu_padre_id == idPadre && dataMenu.menu.estado)
          {
            const result = elementos.find(({ name }) => name === dataMenu.menu.name);
            if(!result){
              if(dataMenu.menu.name != 'EmbargosActivos' && dataMenu.menu.name != 'EmbargosPasivos' && dataMenu.menu.name != 'TrazabilidadEmbargosActivos'){
                elementos.push({
                  alias: dataMenu.menu.alias, 
                  name:  dataMenu.menu.name,
                  current: (dataMenu.menu.name == 'EmbargosPersonas') ? true : false   
                });
              }
            }
          }
        }
      }
      
      //   {alias: "Embargos Activos", name: "EmbargosActivos", current: false},
      //   {alias: "Embargos Pasivos", name: "EmbargosPasivos", current: true},
      //   {alias: "Informes", name: "EmbargosPasivosInformes", current: false}
      //   ,{alias: "Historial Consultas", name: "TrazabilidadEmbargosActivos", current: false}];

      return elementos;
    };

    /**
     * Referencia reactiva a las opciones del menú inferior.
     * @name menuInferior
     * @type {object}
     * @property {array} value - Arreglo con las opciones del menú inferior.
     */
    const menuInferior = ref(cargarMenuInferior());

    return {
      menuInferior: menuInferior
    };
  }
};
</script>